import axios from 'axios';

const url = process.env.REACT_APP_RESTAPI;
const urlV3 = process.env.REACT_APP_RESTAPI_V3;
const wsLogin = process.env.REACT_APP_WEBSOCKET_LOGIN_V3;
const wsLogout = process.env.REACT_APP_WEBSOCKET_LOGOUT_V3;

export const APIWSDisconnect = async (token, agencyOid) => {
    const result = await axios.delete(wsLogout, {
        headers: {
            Authorization: token,
            'agency-id': agencyOid,
        },
    }).catch((error) => error);
    return result;
};

export const APIDeleteTeamMember = async (token, agencyId, params) => {
    const result = await axios.delete(`${urlV3}/team`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APILogoutSessions = async (token, agencyId, params) => {
    const result = await axios.delete(`${urlV3}/sessions`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteAgency = async (token, agencyId, params) => {
    const result = await axios.delete(`${urlV3}/agency`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteGeofence = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/geofences`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteDevice = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/devices`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteAlertPolicy = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/alertPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteBatteryPolicies = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/batteryPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteFuelPolicies = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/fuelPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

export const APIDeleteVehicleAdminPresets = async (token, setLoading, agencyId, params) => {
    setLoading(true);
    const result = await axios.delete(`${urlV3}/vehicleAdminPresets`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        data: params,
    }).catch((error) => error);
    return result;
};

// DELETE fallback across candidate paths (same situation as maintenance PATCH). Try in order; 404/405 try next. Prefer one canonical URL from the API.
export const APIDeleteMaintenanceRecord = async (token, setLoading, agencyId, recordId) => {
    setLoading(true);
    const headers = {
        Authorization: token,
        'agency-id': agencyId,
    };
    const encodedId = encodeURIComponent(recordId);
    const endpoints = [
        `${urlV3}/maintenance/${encodedId}`,
        `${urlV3}/maintenanceRecord/${encodedId}`,
        `${urlV3}/maintenance?id=${encodedId}`,
    ];

    let lastError = null;
    for (let i = 0; i < endpoints.length; i += 1) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await axios.delete(endpoints[i], { headers });
            setLoading(false);
            return result;
        } catch (error) {
            lastError = error;
            const status = error?.response?.status;
            if (status && status !== 404 && status !== 405) {
                setLoading(false);
                return error;
            }
        }
    }

    setLoading(false);
    return lastError;
};
